var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, svg } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ThemedDeviceIcon, deviceIconStyles } from './device-icon-base';
/*
 * <vitesse-plc-icon> — the ONE reusable PLC glyph (the generic controller icon),
 * a faithful port of the Vitesse "PLC & CNC Icon Set" asset. Portrait 200×300.
 *
 * Live status via the `state` attribute (idle | running | error | offline):
 *   running → RUN led breathes green, COM led blinks blue, DI/DO/AI display glows
 *   error   → ERR led pulses red, RUN dims amber
 *   offline → display dims
 * Theme flips with the app's dark/light toggle (reflected onto :host by the base
 * class). Size via `width`/`height`; the viewBox keeps the aspect at any size.
 *
 *   <vitesse-plc-icon state="running" width="46" height="69"></vitesse-plc-icon>
 */
let VitessePlcIcon = class VitessePlcIcon extends ThemedDeviceIcon {
    constructor() {
        super(...arguments);
        this.markup = svg `
    <rect x="46" y="0" width="26" height="16" rx="3" style="fill:var(--bezel)"/>
    <rect x="128" y="0" width="26" height="16" rx="3" style="fill:var(--bezel)"/>
    <rect x="46" y="284" width="26" height="16" rx="3" style="fill:var(--bezel)"/>
    <rect x="128" y="284" width="26" height="16" rx="3" style="fill:var(--bezel)"/>
    <rect x="26" y="12" width="148" height="276" rx="16" style="fill:var(--bezel)"/>
    <rect x="36" y="22" width="128" height="256" rx="9" style="fill:var(--body)"/>
    <rect x="36" y="22" width="128" height="120" rx="9" style="fill:#fff;opacity:.04"/>
    <path d="M36 31a9 9 0 0 1 9-9h110a9 9 0 0 1 9 9v37H36z" style="fill:var(--accent)"/>
    <text x="50" y="55" style="font:700 27px 'IBM Plex Mono',monospace;fill:var(--header-tx)">PLC</text>
    <circle class="led led--run" cx="55" cy="100" r="7"/>
    <circle class="led led--err" cx="55" cy="132" r="7"/>
    <circle class="led led--com" cx="55" cy="164" r="7"/>
    <text x="70" y="105" style="font:600 13px 'IBM Plex Mono',monospace;fill:var(--label)">RUN</text>
    <text x="70" y="137" style="font:600 13px 'IBM Plex Mono',monospace;fill:var(--label)">ERR</text>
    <text x="70" y="169" style="font:600 13px 'IBM Plex Mono',monospace;fill:var(--label)">COM</text>
    <rect x="116" y="92" width="42" height="34" rx="5" style="fill:var(--port-bg)"/>
    <rect x="124" y="101" width="26" height="13" rx="2.5" style="fill:var(--body)"/>
    <rect x="132" y="111" width="10" height="6" rx="2" style="fill:var(--body)"/>
    <text x="137" y="140" text-anchor="middle" style="font:600 11px 'IBM Plex Mono',monospace;fill:var(--label)">ETH</text>
    <rect x="36" y="186" width="128" height="22" style="fill:var(--display-bg)"/>
    <text class="disp-glow" x="48" y="202" style="font:600 13px 'IBM Plex Mono',monospace;fill:var(--display-tx)">DI DO AI</text>
    ${[45, 67, 89, 111, 133, 155].map((cx) => svg `<g>
        <circle cx="${cx}" cy="230" r="8" style="fill:var(--plate);stroke:var(--outline)"/>
        <line x1="${cx - 4}" y1="228" x2="${cx + 4}" y2="232" style="stroke:var(--screw);stroke-width:1.6"/>
      </g>`)}
    <rect x="41" y="248" width="24" height="20" rx="4" style="fill:var(--amber);opacity:.9"/>
    <line x1="47" y1="255" x2="59" y2="261" style="stroke:#7a5200;stroke-width:2"/>
    <rect x="67" y="248" width="24" height="20" rx="4" style="fill:var(--blue);opacity:.9"/>
    <line x1="73" y1="255" x2="85" y2="261" style="stroke:#0b2f66;stroke-width:2"/>
    <circle cx="105" cy="258" r="8" style="fill:var(--plate);stroke:var(--outline)"/>
    <circle cx="135" cy="258" r="8" style="fill:var(--plate);stroke:var(--outline)"/>
  `;
    }
    static { this.styles = deviceIconStyles; }
    render() {
        const w = this.width || 48;
        const h = this.height || 72;
        return html `<svg
      width=${w}
      height=${h}
      viewBox="0 0 200 300"
      role="img"
      aria-label="PLC"
      data-state=${this.state}
      part="svg"
    >
      ${this.markup}
    </svg>`;
    }
};
VitessePlcIcon = __decorate([
    customElement('vitesse-plc-icon')
], VitessePlcIcon);
export { VitessePlcIcon };
//# sourceMappingURL=vitesse-plc-icon.js.map